// extracted by mini-css-extract-plugin
export var growableInput = "_7x-0";
export var tagContainer = "_7x-2";
export var textInput = "_7x-1";